import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  viewBox: "0 0 24 24",
  fill: "currentColor",
  "aria-hidden": "true",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  d: "M10.639 7.398a.75.75 0 1 1 0 1.5h-1.75a.75.75 0 0 1 0-1.5zM15.083 7.398a.75.75 0 0 1 0 1.5h-1.75a.75.75 0 0 1 0-1.5z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M15.032 1.473a3.494 3.494 0 0 1 3.496 3.49V6.05q.396.177.785.376l.45.24.065.041a.75.75 0 0 1-.791 1.272 15 15 0 0 0-.51-.269v13.143a2.123 2.123 0 0 1-2.122 2.12H7.299a2.123 2.123 0 0 1-2.123-2.12V7.936l-.196.11a.75.75 0 0 1-.76-1.292q.472-.277.956-.517V4.964a3.494 3.494 0 0 1 3.497-3.491zm1.996 5.584C13.699 5.824 9.995 5.826 6.676 7.2v13.65c0 .342.278.622.623.622h9.106c.345 0 .622-.28.623-.621zM8.673 2.973a1.994 1.994 0 0 0-1.997 1.99v.63c3.356-1.234 7.011-1.235 10.352-.127v-.502a1.994 1.994 0 0 0-1.996-1.991z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.278 18.804c.349.038.622.358.622.746s-.273.708-.622.746l-.07.004H8.792c-.382 0-.692-.336-.692-.75s.31-.75.692-.75h6.416zM15.278 16.004c.349.038.622.358.622.746s-.273.708-.622.746l-.07.004H8.792c-.382 0-.692-.336-.692-.75s.31-.75.692-.75h6.416zM15.278 13.204c.349.038.622.358.622.746s-.273.708-.622.746l-.07.004H8.792c-.382 0-.692-.336-.692-.75s.31-.75.692-.75h6.416zM15.278 10.404c.349.038.622.358.622.746s-.273.708-.622.746l-.07.004H8.792c-.382 0-.692-.336-.692-.75s.31-.75.692-.75h6.416z"
}));
const ForwardRef = forwardRef(SvgComponent);
export const FifthRowSeatsIcon = ForwardRef;